
import Vue from "vue";
export default Vue.extend({
	computed: {
		anchor():HTMLAnchorElement {
			return this.$refs.anchor as HTMLAnchorElement ;
		}
	},
	methods: {
		onClick() {
			this.$emit("click");
		}
	}
})
;